var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        width: _vm.size,
        height: _vm.size,
        viewBox: "0 0 14 14",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }
    },
    [
      _c("path", {
        attrs: {
          d:
            "M5.41344 4.53844C5.58546 4.51818 5.76038 4.5427 5.92061 4.61071H5.91995L13.2455 7.60746L13.2461 7.60811C13.4418 7.68838 13.6072 7.82844 13.7181 8.0085C13.8291 8.18869 13.8804 8.39975 13.864 8.61071C13.8475 8.82167 13.7645 9.02214 13.627 9.18298C13.4895 9.34379 13.3042 9.45622 13.0983 9.50524L13.099 9.50589L10.1999 10.1999L9.50654 13.0957C9.45807 13.3023 9.34533 13.4888 9.18428 13.627C9.02333 13.765 8.82273 13.8481 8.61136 13.8646C8.39987 13.8811 8.18831 13.8303 8.00785 13.7188C7.82734 13.6072 7.68668 13.4408 7.6068 13.2442V13.2435L4.60745 5.91214V5.91149C4.53277 5.73071 4.51284 5.53203 4.55016 5.33988L4.56709 5.26696C4.61275 5.09993 4.70121 4.9473 4.82425 4.82425L4.87894 4.77347C5.01021 4.66049 5.16902 4.58337 5.33988 4.55016L5.41344 4.53844ZM8.4499 11.7832L8.90303 9.88871V9.88805C8.96052 9.64891 9.0832 9.43038 9.25719 9.25654C9.43123 9.08274 9.65014 8.96025 9.88936 8.90303L11.7826 8.44925L6.14196 6.14196L8.4499 11.7832ZM2.71683 6.74092C2.97042 6.47399 3.3926 6.46324 3.65954 6.71683C3.92631 6.97044 3.93716 7.39266 3.68363 7.65954L2.4167 8.99287C2.16309 9.25961 1.74086 9.27048 1.47399 9.01696C1.20714 8.7634 1.19645 8.34118 1.4499 8.07425L2.71683 6.74092ZM0.0241218 3.82295C0.122019 3.46807 0.488903 3.25965 0.843783 3.35746L2.77738 3.89066C3.13228 3.98859 3.34078 4.35605 3.24287 4.71097C3.14486 5.06575 2.77741 5.2737 2.42256 5.17581L0.489617 4.64261C0.13474 4.54471 -0.0736791 4.17783 0.0241218 3.82295ZM8.07425 1.4499C8.34118 1.19645 8.7634 1.20714 9.01696 1.47399C9.27048 1.74086 9.2596 2.16309 8.99287 2.4167L7.65954 3.68363C7.39266 3.93716 6.97044 3.92631 6.71683 3.65954C6.46324 3.3926 6.47399 2.97042 6.74092 2.71683L8.07425 1.4499ZM3.82295 0.0241218C4.17783 -0.0736791 4.54471 0.13474 4.64261 0.489617L5.17581 2.42256C5.2737 2.77741 5.06575 3.14486 4.71097 3.24287C4.35605 3.34078 3.98859 3.13228 3.89066 2.77738L3.35746 0.843783C3.25965 0.488903 3.46807 0.122019 3.82295 0.0241218Z",
          fill: _vm.fill
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }